import TableComponent, {TablePaginator} from "./TableComponent";
import {useEffect, useState} from "react";
import Axios from "axios";
import {API} from "../../network/API";

export const AutoTableActions = {
    DATA_CHANGED : "autotable.dataChanged",
    PAGE_CHANGED : "pageChanged",
    ROW_CLICKED : "rowClicked",
    SORT_CHANGE : "autotable.sortChange",
    NETWORK_IN_FLIGHT : "networkInFlight",
    ERROR : "error"
};

export const AutoTable = (props) => {

    const {url} = props;
    const {data} = props;
    const {method} = props;
    const {page} = props;
    const {pageSize} = props;
    const {callback} = props;
    const {emptyMessage} = props;
    const {ordering} = props;
    const {dataKey} = props;
    const {mutation} = props;

    const [tableData, setTableData] = useState([]);
    const [totalCount, setTotalCount] = useState([]);
    const [networkInFlight, setNetworkInFlight] = useState(false);

    useEffect(() => {
        if (url) {
            fetchTableDataFromNetwork();
        }
    }, []);

    useEffect(() => {
        fetchTableDataFromNetwork();
    }, [url, data, method, page, pageSize, ordering, mutation])

    useEffect(() => {
        handleCallback(AutoTableActions.NETWORK_IN_FLIGHT, networkInFlight);
    }, [networkInFlight]);

    function handleCallback(action, data) {
        if (callback) {
            callback(action, data);
        }
    }

    function fetchTableDataFromNetwork() {
        if (networkInFlight) return;
        setNetworkInFlight(true);

        let useData = data;
        if (!useData) {
            useData = {};
        }

        useData.page = page;
        useData.pageSize = pageSize;
        useData.ordering = ordering;

        let executor;
        if (method === "get") {
            // TODO Query params
            executor = Axios.get(url);
        } else {
            executor = Axios.post(url, useData);
        }

        executor
            .then((r) => {
                const resp = API.parse(r);
                if (resp.success) {
                    let useKey = "data";
                    if (dataKey) {
                        useKey = dataKey;
                    }

                    console.log("AUTOTABLE. DataKey: " + dataKey);
                    console.log(resp.data);
                    if (resp.data.hasOwnProperty(useKey)) {
                        console.log("Body has property: " + useKey);
                        console.log(resp.data[useKey]);
                        setTableData(resp.data[useKey]);
                    }
                    setTotalCount(resp.data.count);

                    handleCallback(AutoTableActions.DATA_CHANGED, resp.data);
                } else {
                    handleCallback(AutoTableActions.ERROR, API.formatError(resp));
                }
                setNetworkInFlight(false);
            })
            .catch((e) => {
                console.log(e);
                setNetworkInFlight(false);
                handleCallback(AutoTableActions.ERROR, null);
            });
    }

    console.log("RENDER: pageSize: " + pageSize + " :: Total Count: " + totalCount);
    let paginator = [];
    if (pageSize && totalCount > pageSize) {
        console.log("SHOW PAGINATOR");
        paginator = (
            <div className={"ep-table-paginate-container mt-1"}>
                <div className={"push"} />
                <TablePaginator
                    page={page}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onClick={(page) => handleCallback(AutoTableActions.PAGE_CHANGED, page)} />
            </div>
        )
    }

    return (
        <>
            <div className={"table-container"}>
                <TableComponent
                    className={"clickable"}
                    data={tableData}
                    emptyMessage={emptyMessage}
                    placeholderMode={networkInFlight}
                    placeholderRows={pageSize}
                    sortedColumn={ordering}
                    onRowClick={(row) => handleCallback(AutoTableActions.ROW_CLICKED, row)}
                    onSort={(sorting) => handleCallback(AutoTableActions.SORT_CHANGE, sorting)}>

                    {props.children}

                </TableComponent>
            </div>

            {paginator}
        </>
    )

}